import Input2 from '../../../components/input2';
import SubmitBtn2,{SubmitBtn3} from '../../../components/submit2';
import sty from './s.module.scss';

import Footer2 from '../../../components/footer2';
import Header2 from '../../../components/header2';
import { Outlet, Link, useLoaderData, useActionData, Form } from 'react-router-dom';
import { useRef } from 'react';

import Notif from '../../../components/notif';
import { loaderPostFetch } from '../util';
import { useEffect, useState } from 'react';
import {wpUser,production} from '../../../../k';

import PinInput1 from './components/addpin';
import PinInput2 from './components/confirmpin';
import Button1 from './components/button1';



export async function signupaction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  const email = formData.get('email');
  const password = formData.get('password');
  const errors = {};

  // validate the fields
  if (typeof email !== 'string' || !email.includes('@')) {
    errors.error = true;
    errors.email = "That doesn't look like an email address";
  }

  if (typeof password !== 'string' || password.length < 6) {
    errors.error = true;
    errors.password = 'Password must be > 6 characters';
  }

  // return data if we have errors
  if (Object.keys(errors).length) {
    return errors;
  }

  const updates = Object.fromEntries(formData);
  formData.append('fullname', `${updates?.first_name} ${updates.last_name}`);

  return formData;

  const contact = await loaderPostFetch(`api/users.php?crud=newuser`, formData);

  return {...contact,data:updates};
  //return { contact };
}

export default function Signup() {


  let rData = useActionData();


  const [loading, setLoading] = useState(false);
  let [actionData,sactionData] = useState();

  let [pin1,setPin1] = useState();
  let [pin2,setPin2] = useState();

  const [displayId, setDisplayId] = useState(1);
  
  const onPin1Set=(v)=>{
    setPin1(v);
    //setDisplayId(3);
  }
  const formRef = useRef();

  const handleExternalSubmit = () => {
    if (formRef.current) {
      formRef.current.requestSubmit(); // triggers HTML form submit
    }
  };
  const onPin2Set=(v)=>{
    setPin2(v);
    handleExternalSubmit();
  }

  useEffect(()=>{

    if(rData){
      console.log("this");
      setLoading(true);
      loaderPostFetch(`api/users.php?crud=newuser`, rData).then((c)=>{
        sactionData(c);
        setLoading(false);
      })
      .catch((e)=>{
setLoading(false);
      });

    } 

  },[rData]);

  //let actionData = useActionData();
  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      if (s?.error) {
        //s?.message
        if (typeof s?.message=='undefined') {
          sN({ display: true, type: 'error', msg: `Password should be at least 8 characters` });
        }else{
          sN({ display: true, type: 'error', msg: `${s?.message}` });
        }
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      } else {
        //window.localStorage.setItem('baUid', s?.jwt);
        //window.location.reload();

        if (typeof s?.message=='undefined') {
          sN({ display: true, type: 'success', msg: `Signup successful` });
        }else{
          sN({ display: true, type: 'success', msg: `${s?.message}` });
        }
        setTimeout(() => {
          sN({ display: false, type: 'success', msg: `` });
          //window.location.href = '../../dashboard';
          if (typeof s?.data?.email=="undefined") {
          //  window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.email}`;
          window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`;
          
          }else{
          //  window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`; 
            window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`;
          
            //window.location.href = `${wpUser}/account/v/${s?.data?.email}`;
          }
        }, 5000);
      }
    }
  }, [actionData]);


  const [pat2, setPat2] = useState(`.{6,6}|[0-9]*`);

  function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    function handleChange(e) {
        //setValue(e.target.value);
        if(!e.target.value) return;

  // if non numeric
  let isNum = e.target.value[e.target.value.length - 1].match(/[0-9]/g);
  if(!isNum) e.target.value = e.target.value.substring(0, e.target.value.length - 1);


  setPat2(escapeRegExp(e.target.value));

    }



  // Validation functions
  const validateName = (name) => {
    if (!name.trim()) return 'Name is required.';
    return '';
  }; 
  const validateEmail = (email) => {
    if (!email) return 'Email is required.';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) ? '' : 'Invalid email format.';
  };
  const [formData, setFormData] = useState({
    first_name: '',
    email: '',
    last_name: '',
    username: '',
  });

  const [errors, setErrors] = useState({
    first_name: '',
    email: '',
    last_name: '',
    username: '',
  }); 
  const [isValid, setIsValid] = useState(false);
  const handleChange2 = (e) => {
    const { name, value } = e.target; 
    setFormData((prev) => ({ ...prev, [name]: value })); 
    // Field-specific validation
    let error = '';
    if (name === 'first_name') error = validateName(value);
    if (name === 'email') error = validateEmail(value);
    if (name === 'last_name') error = validateName(value); 
    if (name === 'username') error = validateName(value); 
    setErrors((prev) => ({ ...prev, [name]: error }));
  };
  // Form-wide validation: enable submit only when all fields are valid
  useEffect(() => {
    const nameError = validateName(formData.first_name);
    const emailError = validateEmail(formData.email);
    const passwordError = validateName(formData.last_name); 
    const unError = validateName(formData.username); 
    setErrors({ first_name: nameError, email: emailError, last_name: passwordError,
     username: unError  }); 
    const allValid = !nameError && !emailError && !passwordError && !unError;
    setIsValid(allValid);
  }, [formData]);

  //requires params
  return (
    <div>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <Header2 href={`${wpUser}/account/${window['login']}`} title="Sign In" />


      <div style={{display:`${displayId==1?'grid':'none'}`}} >

      <div className={sty.sub}>
        <div className={sty.text}>Set up your profile</div>

        <div className={sty.pen}></div>
      </div>

      <div className={sty.s}>create an account so you can manage your money faster</div>
 
      <Form method="post" ref={formRef}>

          <Input2 type="text" onChange={handleChange2} required={true} placeholder="First Name" name="first_name" />
          <Input2 type="text" onChange={handleChange2} required={true} placeholder="Last Name" name="last_name" />
          <Input2 type="text" onChange={handleChange2} required={true} placeholder="Username" name="username" />
          <Input2 type="email" onChange={handleChange2} required={true} placeholder="Email" name="email" />  
          {/*
          <Input2 type="text" required={true} placeholder="First Name" name="first_name" />*/} 
           
          <input type="hidden" value={pin1} name="password" />
          <input type="hidden" value={pin2} name="conf_password" />
          {/*<Input2 name="password" maxlength={6} pattern=".{6,6}|[0-9]*" oninput={handleChange} required={true} title="Passcode must be 6 digits" type="password" placeholder="Create passcode (6 digits)" hasIcon="show" toggleIconWith="hide" />
          <Input2 type="password" maxlength={6} pattern={pat2} title="Confirm Password must be 6 digits and same as Passcode"  required={true} placeholder="Confirm Passcode" hasIcon="show" toggleIconWith="hide" />
          */}
          <div className={sty.remeber}>
            <div className={sty.l}>
              <input type="checkbox" required />
              <div className={sty.text}>I&apos;m at least 18 years old and agree to the following terms:</div>
            </div>
            {/*<div className={sty.r}>
        		<a href="">Forgot Password?</a>
        		</div>*/}
          </div>

          {/*<div className={sty.note}>
            By tapping Next. I've read and agree to the &nbsp;
            <a className={sty.imp} href="/b/sign.pdf">
              E-Sign Disclosure and Consent
            </a>{' '}
            to receive all communications electronically
          </div>*/} 
          
          {/*<SubmitBtn3 label="Continue" loading={loading} />
        */}

          <Button1 disabled={!isValid} onClick={()=>{
            setDisplayId(2);
          }} title="Next" />

      </Form>
      
      </div>

        <PinInput1 displayId={displayId} onPinSet={onPin1Set} setDisplayId={setDisplayId} />
        <PinInput2 displayId={displayId} onPinSet={onPin2Set} sN={sN} lastPin={pin1} setDisplayId={setDisplayId} />

      <Footer2 />
    </div>
  );
}
